import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import ApiCalls from '../../../common/ApiCalls';
import IconButton from '@mui/material/IconButton';
import { useHMapContext } from '../hooks/useHMapContext';
import { ReactComponent as PinFull } from '../../../components/1elements/Icons/svg/heatMap/pinFull.svg';
import { ReactComponent as PinEmpty } from '../../../components/1elements/Icons/svg/heatMap/pinEmpty.svg';

const HMapContainerPin = ({
  id,
  name,
  pin,
  className,
  disabled,
  type,
  allHeatMaps,
  setAllHeatMaps,
  setShowLoader
}) => {
  const classes = useStyles({ pin, disabled });
  const { userIdRef, snackbar } = useHMapContext();
  const [isSnackbarOpen, setIsSnackbarOpen] = snackbar;
  const userId = userIdRef.current;
  const isDefaultHeatmap = useMemo(
    () => name && name.toLowerCase() === 'default heatmap',
    [name]
  );

  const toggleHandler = () => {
    // Show Loader
    setShowLoader(true);

    // pin functions
    const { addHeatmapAttribute, removeHeatmapAttribute } = ApiCalls();

    // add or remove pin
    const currentMapDetails = allHeatMaps.filter((item) => item.id === id);
    const { pin } =
      currentMapDetails && currentMapDetails.length && currentMapDetails[0];

    // pin function based on the current pin value
    const pinfunction = !pin ? addHeatmapAttribute : removeHeatmapAttribute;

    pinfunction(userId, id, 'pin')
      .then((data) => {
        // added timeout to prevent consequent clicks
        // minimum wait = 0.5s
        setTimeout(() => {
          // add or remove pin from the heatmap
          setAllHeatMaps([
            ...allHeatMaps.map((item) =>
              item.id === id ? { ...item, pin: !pin } : item
            )
          ]);

          // show loader
          setShowLoader(false);

          // display snackbar with success message
          setIsSnackbarOpen({
            ...isSnackbarOpen,
            message: `You heatmap is ${pin ? 'un' : ''}pinned successfully`,
            severity: 'success',
            isOpen: true
          });
        }, 500);
      })
      .catch((err) => {
        // Show Loader
        setShowLoader(false);
        // display snackbar with error message
        setIsSnackbarOpen({
          ...isSnackbarOpen,
          message: err.message,
          severity: 'fail',
          isOpen: true
        });
      });
  };

  const iconButtonProps = {
    name: `${name}_pin`,
    'aria-label': 'expand row',
    size: 'small',
    ...(className && { className: `${classes.root} ${className}` }),
    ...(!disabled && { onClick: toggleHandler })
  };

  if (isDefaultHeatmap) {
    return <></>;
  }

  return (
    <IconButton {...iconButtonProps}>
      {pin ? (
        <PinFull className={classes.iconFull} />
      ) : (
        <PinEmpty className={classes.iconEmpty} />
      )}
    </IconButton>
  );
};

export default React.memo(HMapContainerPin);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '20px',
    height: '20px'
  },
  iconFull: {
    width: '20px',
    height: '20px',
    color: theme.palette.primary.accent,
    fill: theme.palette.primary.accent
  },
  iconEmpty: {
    width: '20px',
    height: '20px',
    color: theme.palette.tertiary.accent,
    fill: theme.palette.tertiary.accent
  }
}));
